import styled from 'styled-components';

export const StyledFilter = styled.div`
  width: 100%;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  margin-bottom: 24px;
  &::-webkit-scrollbar {
    display: none;
  }
`;
